import React, { useEffect } from 'react';
import './BodasPage.css';
import ContactButton from '../../../../atoms/ContactButton/ContactButton';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Trans, useTranslation } from 'react-i18next'; 

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// 2. ---  IMÁGENES PARA EL PRIMER CARRUSEL ---
import carruselImg1 from '../../../../../assets/bodas/bodas1.png';  
import carruselImg2 from '../../../../../assets/bodas/bodas2.png';  
import carruselImg3 from '../../../../../assets/bodas/bodas3.png';  
import carruselImg4 from '../../../../../assets/bodas/bodas4.png';  
import carruselImg5 from '../../../../../assets/bodas/bodas5.png';  
import carruselImg6 from '../../../../../assets/bodas/bodas6.png';  
import carruselImg7 from '../../../../../assets/bodas/bodas7.png';  
import carruselImg8 from '../../../../../assets/bodas/bodas8.png';  
import carruselImg9 from '../../../../../assets/bodas/bodas9.png';  
import carruselImg10 from '../../../../../assets/bodas/bodas10.png';  
import carruselImg11 from '../../../../../assets/bodas/bodas11.png';  
import carruselImg12 from '../../../../../assets/bodas/bodas12.png';  
import carruselImg13 from '../../../../../assets/bodas/bodas13.png';  
import carruselImg14 from '../../../../../assets/bodas/bodas14.png';  

import bodasHero from '../../../../../assets/BodasHero.png';

const carouselImages = [
  carruselImg1,
  carruselImg2,
  carruselImg3,
  carruselImg4,
  carruselImg5,
  carruselImg6,
  carruselImg7,
  carruselImg8,
  carruselImg9,
  carruselImg10,
  carruselImg11,
  carruselImg12,
  carruselImg13,
  carruselImg14,
];

const BodasPage: React.FC = () => {
  
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200, 
      once: true,     
    });
  }, []);

  return (
    <div className="bodas-page-container">
      
      {/* --- Hero Section --- */}
      <header
        className="bodas-hero fade-in"
        style={{ backgroundImage: `url(${bodasHero})` }}
        data-aos="fade-in"
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title" data-aos="fade-down">
          <Trans i18nKey="weddingsPage:heroTitle" />
        </h1>
      </header>

      {/* --- Info Section (Negra) --- */}
      <section className="bodas-info-black fade-up" data-aos="fade-up">
        <h2 className="info-title" data-aos="fade-up">
          <Trans i18nKey="weddingsPage:info.title" />
        </h2>
        <p className="info-text" data-aos="fade-up">
          <Trans 
            i18nKey="weddingsPage:info.description"
            components={{ strong: <strong /> }}
          />
        </p>
      </section>

      {/* --- carrusel --- */}
      <section className="vgrid-carrusel fade-up" data-aos="fade-up">
        <div className="restaurant-carousel-wrapper" data-aos="fade-left">
          <Swiper
            modules={[Navigation]} 
            navigation 
            slidesPerView={2} 
            loop={true} 
            className="restaurant-swiper"
            breakpoints={{
              0: { slidesPerView: 1 },
              769: { slidesPerView: 2 },
            }}
          >
            {carouselImages.map((imgSrc, index) => (
              <SwiperSlide key={index}>
                <img
                  src={imgSrc}
                  alt={`Bodas ${index + 1}`}
                  className="restaurant-carousel-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* --- Call to Action Section (Blanca) --- */}
      <section className="bodas-cta-white fade-up" data-aos="fade-up">
        <p data-aos="fade-up">
          <Trans 
            i18nKey="weddingsPage:cta.text"
            components={{ 
              strong: <strong />,
              br: <br />
            }}
          />
        </p>
        <div className='bodas-cta-contact'>
          <a href="mailto:reservas@villasflamingos.com" target='_blank'>reservas@villasflamingos.com</a>
        <p>WhatsApp: <a href="https://wa.link/cxosi3" target='_blank'>+52 984 125 0102</a></p>
        </div>
        <ContactButton />
      </section>

    </div>
  );
};

export default BodasPage;